export default __webpack_public_path__ + "static/media/attractive-happy-man-using-laptop-park-watching-video-podcast-fresh-air (1).8ce4575e.jpg";